// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"amount-display__container___2m-En","major":"amount-display__major___3K5TH","medium":"amount-display__medium___2xQdv","small":"amount-display__small___1T_s3","large":"amount-display__large___3eSw4","currency-symbol":"amount-display__currency-symbol___y5caR","currencySymbol":"amount-display__currency-symbol___y5caR"};
    if(module.hot) {
      // 1745303700812
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  